/**
 * Etiqueta-resumen flotante sobre el mapa.
 *
 * Sirve para revisar en vivo durante el levantamiento; la lámina exportada arma
 * su propio resumen en canvas y no lee este DOM.
 */

import { formatArea } from '../domain/document.js';
import { isInstalledMode, totalEquipment, verticalEquipment } from '../domain/inventory.js';
import { AED_SVG } from '../map/icons.js';

const row = (label, value, withDot = false) =>
  `<div class="rr"><span class="lab">${withDot ? '<span class="cob"></span>' : ''}${label}</span><b>${value}</b></div>`;

export function renderSummary(element, sheet) {
  if (!element) return;

  const installed = isInstalledMode(sheet.deas);
  const total = totalEquipment(sheet.deas, sheet.buildings);
  const vertical = verticalEquipment(sheet.deas, sheet.buildings);
  const title = installed ? 'TOTAL EQUIPOS DEA INSTALADOS' : 'TOTAL EQUIPOS DEA ESTIMADOS';
  const verticalLabel = installed ? 'DEA en altura' : 'Vertical (por instalar)';

  const parts = [
    `<div class="rt">${title}</div>`,
    `<div class="rn">${AED_SVG}<span class="n">${total}</span></div>`,
    row('Radio de cobertura por DEA', `${sheet.radius} m`, true),
  ];

  if (sheet.buildings.length) parts.push(row(verticalLabel, `${vertical} DEA`));
  parts.push(row('Superficie protegida', sheet.areaM2 > 0 ? formatArea(sheet.areaM2) : '—'));
  if (sheet.coveragePct != null) parts.push(row('Cobertura del recinto', `${sheet.coveragePct}%`));

  if (sheet.deas.length) {
    parts.push(row('Color del círculo', '1 por cada DEA'));
    parts.push(row('Adquirido / Propuesto', 'línea sólida / punteada'));
  }
  if (sheet.buildings.length) {
    parts.push(row('Piso del edificio', 'verde=DEA instalado'));
  }

  element.innerHTML = parts.join('');
}
